var map = {
	"./1-naturalway-logo.jpeg": 90,
	"./Avisha_headshot.png": 30,
	"./address_image.svg": 91,
	"./animated_logo.svg": 92,
	"./bgsu-logo.jpg": 93,
	"./blogs_image.svg": 94,
	"./cloud_infrastructure.svg": 95,
	"./codeInLogo.png": 96,
	"./contactMail.png": 97,
	"./coursera_logo.png": 98,
	"./data_science.svg": 99,
	"./deeplearning_ai_logo.png": 100,
	"./delhivery_logo.png": 101,
	"./developerActivity.svg": 102,
	"./dsc_logo.png": 103,
	"./education.svg": 104,
	"./experience.svg": 105,
	"./feelingProud.svg": 106,
	"./freecopy_logo.png": 107,
	"./fullstack.svg": 108,
	"./gcp_logo.png": 109,
	"./googleAssistant.jpg": 110,
	"./googleAssistant.svg": 111,
	"./google_logo.png": 112,
	"./ibm_logo.png": 113,
	"./iu_logo.png": 114,
	"./jsFramework.svg": 115,
	"./legato_logo.png": 116,
	"./manOnTable.svg": 117,
	"./microsoft_logo.png": 118,
	"./mozilla_logo.png": 119,
	"./nptel_logo.png": 120,
	"./programmer.svg": 121,
	"./projects_image.svg": 122,
	"./pwa.png": 123,
	"./rgtu-logo.jpeg": 124,
	"./talksCardBack.svg": 125,
	"./talksCardBackAlt.svg": 126,
	"./tcs-logo.png": 127,
	"./ui_ux_design.svg": 128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;